(() => {
  const COMING_SOON_TEXT = /coming\s*soon/i;

  const mainSubmitButton = () => document.querySelector('[id^="ProductSubmitButton-"]');

  const pageHasComingSoonNotice = () =>
    COMING_SOON_TEXT.test(document.body?.innerText || '') ||
    [...document.querySelectorAll('[class*="coming"], [id*="coming"], [data-coming-soon]')]
      .some((element) => COMING_SOON_TEXT.test(element.textContent || ''));

  const mainButtonIsBlocked = () => {
    const button = mainSubmitButton();
    if (!button) return false;
    return button.disabled || button.getAttribute('aria-disabled') === 'true' || button.dataset.unavailable === 'true';
  };

  const shouldBlockStickyAdd = () => pageHasComingSoonNotice() || mainButtonIsBlocked();

  const scrollToMainButton = () => {
    const target =
      document.querySelector('[class*="coming"], [id*="coming"], [data-coming-soon]') ||
      mainSubmitButton();
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('sticky-atc [id^="SectionAtcBtn-"], sticky-atc .main-product-atc');
      if (!button || !shouldBlockStickyAdd()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      scrollToMainButton();
    },
    true
  );
})();
